import { sendEventRegist } from 'helpers/analytics';
import {
  getChannelContextAdditionalInfo,
  getChannelContextCode
} from 'helpers/Utility';
import { setError, setRegisteredPin } from 'store/actions/auth';

const handleUnauthorized = (dispatch, pin, callback) => {
  dispatch(setRegisteredPin(pin));
  callback?.('success');
};

const handleOtpFailed = callback => {
  callback?.('failed');
};

const handleContactCsError = dispatch => {
  sendEventRegist({
    action: 'Error while delivering the OTP',
    label: 'OTP'
  });
  dispatch(setError('contact-cs'));
};

const handleRepeatedPin = callback => {
  callback?.('repeated');
};

const handleConnectionError = dispatch => dispatch(setError('connection'));

const handleSystemError = dispatch => dispatch(setError('system'));

/**
 * Main function to handle create PIN error
 * @param {*} err
 * @param {*} status
 * @param {*} callback
 * @param {*} dispatch
 * @param {*} pin
 * @returns
 */
export const handleErrorCreatePin = (err, status, callback, dispatch, pin) => {
  if (!err.response) return handleConnectionError();

  if (status === 401) return handleUnauthorized(dispatch, pin, callback);
  if (getChannelContextCode(err, 'channel-context') === '211091')
    return handleOtpFailed(callback);
  if (getChannelContextCode(err, 'channel-context') === null)
    return handleSystemError(dispatch);
  if (getChannelContextCode(err, 'channel-context') === '200604')
    return handleContactCsError(dispatch);
  if (getChannelContextCode(err, 'channel-context') === '100473')
    return handleRepeatedPin(callback);
  if (getChannelContextCode(err, 'channel-context') === '40000001')
    return callback?.('repeated');
  if (getChannelContextCode(err, 'channel-context') === '4000202')
    return dispatch(setError('weakpin'));
  if (getChannelContextCode(err, 'channel-context') === '4000203')
    return callback?.('limit_receive_otp');
  if (getChannelContextCode(err, 'channel-context') === '4000301') {
    const addInfo = getChannelContextAdditionalInfo(err, 'channel-context');
    const freezeTime = addInfo?.freezeEnd;
    localStorage.setItem('otpFreeze', JSON.stringify({ freezeTime }));
    dispatch(setError('otp_temporary_locked'));
    callback?.('otp_temporary_locked');
    return
  }
  handleSystemError(dispatch);
};
